import { createRouter, createWebHashHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import { authService } from '../services/index.js'
import store from '@/store'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView,
    meta: { title: '首页', requiresAuth: true }
  },
  {
    path: '/dictionary',
    name: 'dictionary',
    component: () => import('../views/DictionaryView.vue'),
    meta: { title: '词典', requiresAuth: true }
  },
  {
    // 使用 params 传递 selectionId
    path: '/practice-session/:selectionId',
    name: 'practiceSession', // 新的路由名称
    component: () => import('../views/PracticeSessionView.vue'), // 指向新的视图组件
    meta: { title: '学习中', requiresAuth: true },
    props: true // 允许将路由参数作为 props 传递给组件 (虽然我们现在手动解析)
  },
  {
    path: '/practice',
    name: 'practice',
    component: () => import('../views/PracticeView.vue'),
    meta: { title: '学习计划', requiresAuth: true }
  },
  {
    path: '/progress',
    name: 'progress',
    component: () => import('../views/ProgressView.vue'),
    meta: { title: '进度统计', requiresAuth: true }
  },
  {
    path: '/favorites', // 收藏夹路径
    name: 'favorites',
    component: () => import('../views/FavoritesView.vue'),
    meta: { title: '我的收藏', requiresAuth: true }
  },
  {
    path: '/detailed-progress', // 详细进度路径
    name: 'detailedProgress',
    component: () => import('../views/DetailedProgressView.vue'),
    meta: { title: '详细进度', requiresAuth: true }
  },
  {
    path: '/profile',
    name: 'profile',
    component: () => import('../views/ProfileView.vue'),
    meta: { title: '个人中心', requiresAuth: true }
  },
  {
    path: '/settings',
    name: 'settings',
    component: () => import('../views/SettingsView.vue'),
    meta: { title: '设置', requiresAuth: true }
  },
  {
    path: '/word/:id',
    name: 'wordDetail',
    component: () => import('../views/WordDetailView.vue'),
    meta: { requiresAuth: true }
  },
  {
    path: '/login',
    name: 'LoginRegister',
    component: () => import('../views/LoginRegisterView.vue'),
    meta: { requiresAuth: false }
  }
]

const router = createRouter({
  history: createWebHashHistory(process.env.VUE_APP_ROUTER_BASE),
  routes
})

// 设置页面标题和认证检查
router.beforeEach(async (to, from, next) => {
  document.title = to.meta.title ? `${to.meta.title} | 德语单词学习` : '德语单词学习'

  // 直接使用导入的store，而不是router.app.$store
  const isAuthenticated = store.getters.getIsAuthenticated || await store.dispatch('initAuth')
  
  if (to.meta.requiresAuth !== false && !isAuthenticated) {
    next('/login')
  } else {
    next()
  }
})

export default router 